import type { PaymentType } from '@/src/app/main/(tabs)/card/card-management/_common/paymentAmountSection'
import { create } from 'zustand'
import type { DateType } from '@/src/app/main/(tabs)/card/card-management/_common/dateSectionSection'
import type { ExternalAccount } from '@/src/common/components/fundingSourceSelector'

export interface OneTimePaymentStore {
  paymentAmount: string | undefined
  paymentType: PaymentType | undefined
  setPaymentAmount: (paymentAmount: string | undefined) => void
  setPaymentType: (paymentType: PaymentType | undefined) => void
  paymentDate: string | undefined
  paymentDateType: DateType | undefined
  setPaymentDate: (paymentDate: string | undefined) => void
  setPaymentDateType: (paymentDateType: DateType | undefined) => void
  account: ExternalAccount | undefined
  setAccount: (account: ExternalAccount | undefined) => void
  clear: () => void
}

export const useOneTimePaymentStore = create<OneTimePaymentStore>((set) => ({
  paymentAmount: undefined,
  paymentType: undefined,
  paymentDate: undefined,
  paymentDateType: undefined,
  account: undefined,
  setPaymentAmount: (paymentAmount: string | undefined) => set({ paymentAmount }),
  setPaymentType: (paymentType: PaymentType | undefined) => set({ paymentType }),
  setPaymentDate: (paymentDate: string | undefined) => set({ paymentDate }),
  setPaymentDateType: (paymentDateType: DateType | undefined) => set({ paymentDateType }),
  setAccount: (account: ExternalAccount | undefined) => set({ account }),
  clear: () =>
    set({
      paymentAmount: undefined,
      paymentType: undefined,
      paymentDate: undefined,
      paymentDateType: undefined,
      account: undefined,
    }),
}))
